export const rateTypes = {
  Lables: 'lables',
  Smileys: 'smileys',
  Stars: 'stars',
};
